import { Box, Flex, Text } from '@chakra-ui/react';

import type { HeartbeatColor } from './types/heartbeat-color.type';
import type { HeartbeatStatus } from './types/heartbeat-status.type';

import { useHeartbeatTimerConfiguration } from './hooks/heartbeat-timer-configuration.hook';

const colorMap: Record<HeartbeatStatus, HeartbeatColor> = {
  danger: { border: 'red.300', fill: 'red.200', text: 'red.900' },
  safe: { border: 'green.300', fill: 'green.200', text: 'green.900' },
  warning: { border: 'orange.300', fill: 'orange.200', text: 'orange.900' },
};

const HeartbeatTimer = () => {
  const { label, percentage, status } = useHeartbeatTimerConfiguration();
  const colors = colorMap[status];

  return (
    <Flex
      justifyContent="flex-end"
      px={4}
      py={2}
      width="full">
      <Box
        borderColor={colors.border}
        borderRadius="full"
        borderWidth={1}
        overflow="hidden"
        position="relative"
        transition="border-color 1s ease">
        <Box
          bg={colors.fill}
          bottom={0}
          left={0}
          position="absolute"
          top={0}
          transition="width 1s linear, background 1s ease"
          width={`${percentage}%`}
        />
        <Flex
          alignItems="center"
          color={colors.text}
          fontFamily="mono"
          fontSize="xs"
          fontWeight="bold"
          gap={1}
          position="relative"
          px={3}
          py={1}
          transition="color 1s ease"
          userSelect="none"
          whiteSpace="nowrap">
          Session last validated:
          <Text as="span">{label}</Text>
        </Flex>
      </Box>
    </Flex>
  );
};

export default HeartbeatTimer;
